import Header from "@/components/landing/Header";
import Process from "@/components/landing/Process";
import Footer from "@/components/landing/Footer";
import Seo from "@/components/Seo";

export default function Ablauf() {
  return (
    <>
      <Seo
        title="Ablauf: In vier Schritten nach Florida"
        description="So läuft Ihre Auswanderung nach Florida ab: kostenloses Erstgespräch, persönlicher Fahrplan, Umsetzung & Ankommen – und Begleitung auch nach der Auswanderung."
        keywords="Auswandern Florida Ablauf, Auswanderung USA Schritte, Erstgespräch Auswanderung, Relocation Planung Florida"
      />
      <Header />
      <main className="pt-20" data-testid="ablauf-page">
        <Process />
      </main>
      <Footer />
    </>
  );
}
